import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { BllModal } from './modal.component';

@NgModule({
  imports: [CommonModule, NgbModalModule],
  declarations: [],
  exports: [NgbModalModule],
  providers: [BllModal],
})
export class BllModalModule {}
